export enum RoomTypeEnum {
  Multidisciplinar = 1,
  GO = 2,
  Psico = 3,
  Teleconsulta = 4,
  BIA = 5,
  Extra = 6,
  SalaKids = 7,
  Flex = 8,
}
